import type CommonState from '@modules/store/common/types/CommonState.entity';
import type FetchTranslationsConfig from '@modules/store/common/types/FetchTranslationsConfig.entity';
import type StaticDataState from '@modules/store/common/types/StaticDataState.entity';
import type Translation from '@modules/store/common/types/Translation.entity';
import { ActionTree } from 'vuex';

export const actions: ActionTree<StaticDataState, CommonState> = {
  /*
    Static enum data could also be fetched using the API or the OPENAPI specifications
  */

  fetchTranslations: ({ commit }, config: FetchTranslationsConfig) => {
    config.entries.forEach(entry => {
      const list: string[] = entry.values;
      list.forEach(name => {
        const term = `${entry.translationPath}.${name.replaceAll('.', '{dot}')}`;
        const translatedTerm: string = config.translator.t(`${config.translatorProjectPrefix}.${term}`);
        const translation: Translation = { type: entry.type, name, translation: translatedTerm };
        commit('setTranslation', translation);
      });
    });
  },
};
